import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "login-otp-form__label"
}
const _hoisted_2 = { class: "login-otp-form__error-message" }
const _hoisted_3 = { class: "login-otp-form__or-separator" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicOtpInput = _resolveComponent("BasicOtpInput")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_SecurityProtocolOptions = _resolveComponent("SecurityProtocolOptions")!
  const _component_FormSubmitButton = _resolveComponent("FormSubmitButton")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_FormGroup = _resolveComponent("FormGroup")!

  return (_openBlock(), _createBlock(_component_FormGroup, {
    class: "login-otp-form",
    layout: "vertical",
    "wrapper-col": { span: 24 },
    model: _ctx.loginCheck,
    onFinish: _ctx.submitLogin,
    loading: _ctx.tokenAuthenticateLoading
  }, {
    default: _withCtx(() => [
      (!_ctx.isMobileScreen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.t("Please enter your OTP (One-Time Password) generated")), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_a_form_item, {
        name: "code",
        rules: _ctx.makeRequiredRule(_ctx.t('Please enter OTP code')),
        class: _normalizeClass([
        'login-otp-form__otp-input',
        !!_ctx.tokenAuthParsedError && 'login-otp-form__otp-input--api-error',
      ]),
        validateStatus: !!_ctx.tokenAuthParsedError && 'error'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BasicOtpInput, {
            class: "login-otp-form__basic-input",
            value: _ctx.loginCheck.code,
            "onUpdate:value": [
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginCheck.code) = $event)),
              _ctx.resetErrorMessage
            ],
            onOnComplete: _ctx.submitLogin
          }, null, 8, ["value", "onOnComplete", "onUpdate:value"])
        ]),
        _: 1
      }, 8, ["rules", "class", "validateStatus"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_typography_text, { type: "danger" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.tokenAuthParsedError), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("or")), 1),
      _createVNode(_component_SecurityProtocolOptions, {
        disabled: _ctx.tokenAuthenticateLoading,
        isNonAuthenticated: "",
        hideBackupCodeOption: ""
      }, null, 8, ["disabled"]),
      _createVNode(_component_a_row, { class: "mt-50" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { xs: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_FormSubmitButton, {
                loading: _ctx.tokenAuthenticateLoading,
                disabled: _ctx.isBtnLoading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("Submit")), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "onFinish", "loading"]))
}